
import React, { Component } from "react";
import styled from "styled-components";
import TableCell from "@material-ui/core/TableCell";
import { DateTimeDisplay } from "core/Display";

const StyledTableCellDates = styled(TableCell)`
  font-size: 12px;
  width: 50px;
  line-height: 100%;
  vertical-align: top;
  
  .status {
    margin-top: 5px;
  }
  
  .text-gray {
    font-size: 10px;
  }
  
  .date-value {
    white-space: nowrap;
  }
`;


export default class TableCellStatus extends Component {
  render() {
    const { item } = this.props;
    return (
      <StyledTableCellDates>
        {item.date_start && (
          <div className={'date-value'}>
            <DateTimeDisplay value={item.date_start} format={'DD.MM HH:mm'} />
          </div>
        )}

        <div className={'mt-2 text-gray'}>—</div>

        {item.date_end && (
          <div className={'mt-2 date-value'}>
            <DateTimeDisplay value={item.date_end} format={'DD.MM HH:mm'} />
          </div>
        )}
        {!item.date_end && (<div className={'mt-3'}>...</div>)}
      </StyledTableCellDates>
    )
  }
}
